import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import IapPropertiesCls from './IapPropertiesCls';
import { OrbUserContext } from '../OrbUserContext';

export interface IIapPropertiesProps extends IUseApiProps, IWithErrorHandlingProps {
}

const IapProperties = (props: IIapPropertiesProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <IapPropertiesCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(IapProperties);
